module.exports = __webpack_public_path__ + "img/matador-gif_2.cac7a80a.gif";